import { ColumnEditorOptions } from "primereact/column";
import { InputTextarea } from "primereact/inputtextarea";
import { ChangeEvent } from "react";

interface TextEditorProps {
    options: ColumnEditorOptions;
    maxLength?: number;
}

export const TextEditor = ({ options, maxLength }: TextEditorProps) => {
    const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        if (options.editorCallback) {
            options.editorCallback(event.target.value);
        }
    };

    return (
        <InputTextarea
            autoResize
            autoFocus
            value={options.value || ""}
            onChange={handleChange}
            maxLength={maxLength}
        />
    );
};
